<template>
    <div class="hitchRideSettleRule">
      <custom-org-tree @selected="handleSelect" url="/api/v1/manage/hitchRide/commissionRule"/>
  
        <div class="hitchRideSettleRule-content">
          <rakeRulesForm :cityData="{ ...selectCity }"></rakeRulesForm>
        </div>
    </div>
  </template>
  
  <script>
  import CustomOrgTree from './components/CustomOrgTree.vue';
  import rakeRulesForm from './components/rakeRulesForm.vue'
  export default {
    components: { CustomOrgTree, rakeRulesForm },
    data() {
      return {
        selectCity: {}
      };
    },
    computed: {},
    created() {
      
    },
    methods: {
        handleSelect(node) {
        this.selectCity = node;
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .hitchRideSettleRule{
    display: flex;
  
    &-content {
      padding: 16px;
      flex: 1;
      max-height: calc(100vh - 240px);
      overflow-y: auto;
    }
  }
  </style>